import { countryName } from '@dayon/contracts';

/**
 * WHERE A PLAYER LIVES, rendered the same way everywhere.
 *
 * In `lib` rather than in a feature folder because two features print it — the
 * roster's column and the profile's identity block — and they are not allowed
 * to disagree. The thing they must agree about is the NULL:
 * `player.player.residence_country` is nullable, every account that registered
 * before the column existed carries NULL, and that is "never asked" rather than
 * an answer of any kind.
 *
 * A blank cell would read as an answer. So would a dash, in a table where a
 * dash means zero elsewhere. So this prints the words, in the subdued style the
 * console uses for "the platform does not have this", and never leaves the
 * reader to infer which of the two it is.
 */
export function ResidenceValue({ code }: { code: string | null }) {
  if (code === null) {
    return (
      <span className="text-subtle">
        Never asked
      </span>
    );
  }
  const name = countryName(code);
  return (
    <>
      {/* Named from the runtime's own region data — the same source the sign-up
          picker offers and the validator accepts. A code this runtime cannot
          name prints as the bare code rather than as nothing. */}
      {name ?? <span className="text-subtle">unnamed region</span>}{' '}
      <span className="text-subtle tabular">{code}</span>
    </>
  );
}

/** The same fact as a plain string, for a label, a title or a toast. */
export function residenceLabel(code: string | null): string {
  if (code === null) return 'Never asked';
  return `${countryName(code) ?? 'Unnamed region'} (${code})`;
}
